import { getDaysBetween, getDateId } from './DateUtil';

export interface IStateStats {
    msInError: number;
    msTotal: number;
    errorCount: number;
    shortErrorCount: number;
    mediumErrorCount: number;
    errors: any[];
    success: any[];
}

export function calcStats(states: any[], startDate: Date, endDate: Date, shortMinutes: number = 60, longMinutes: number = 120): IStateStats {
    states = states || [];

    const filtered = {
        errors: [],
        success: []
    },
        daysInTimespan = getDaysBetween(startDate, endDate),
        startMs = startDate.getTime(),
        endMs = endDate.getTime(),
        msTotal = endMs - startMs;

    let lastStatusStart,
        msInError = 0,
        errorCount = 0,
        shortErrorCount = 0,
        mediumErrorCount = 0;

    shortMinutes = shortMinutes * 60 * 1000;
    longMinutes = longMinutes * 60 * 1000;

    states.forEach((state) => {
        let statusStart, statusEnd, statusTimespanDays, dayStatusProperty;

        if (state.date.getTime() < startMs) {
            statusStart = startDate;
        } else {
            statusStart = state.date;
        }

        if (state.lastDate.getTime() > endMs) {
            statusEnd = endDate;
        } else {
            statusEnd = lastStatusStart || state.lastDate;
        }

        if (state.state) {
            const msTimespan = statusEnd - statusStart;

            msInError += (statusEnd - statusStart);
            errorCount++;

            if (msTimespan <= shortMinutes) {
                shortErrorCount++;
            } else if (msTimespan <= longMinutes) {
                mediumErrorCount++;
            }
        }

        dayStatusProperty = state.state ? 'errors' : 'success';
        filtered[dayStatusProperty].push(state);

        lastStatusStart = statusStart;
    });

    return {
        msInError: msInError,
        msTotal: msTotal,
        errorCount: errorCount,
        shortErrorCount: shortErrorCount,
        mediumErrorCount: mediumErrorCount,
        errors: filtered.errors,
        success: filtered.success,
    };
}

export function calcChildErrors(node, nodes, states, countMap) {
    const { id } = node;

    const children = nodes.filter(node => {
        return node.parentId === id;
    });

    const counts = countMap[id] = {
        childErrorCnt: 0,
        nodeErrorCnt: 0,
        currentErrorCnt: 0,
        totalErrorCnt: 0,
    }

    counts.nodeErrorCnt = (states[id] || []).filter(state => state.state).length;

    if (!children.length) {
        counts.childErrorCnt = 0;
        counts.currentErrorCnt = node.state ? 1 : 0;
        counts.totalErrorCnt = counts.nodeErrorCnt;
        return node;
    }

    var childErrorCnt = 0,
        currentErrorCnt = node.state ? 1 : 0;

    children.forEach(child => {
        this.calcChildErrors(child, nodes, states, countMap);

        const childId = child.id;
        const childCounts = countMap[childId];

        childErrorCnt += (childCounts.nodeErrorCnt || 0);
        childErrorCnt += (childCounts.childErrorCnt || 0);
        currentErrorCnt += (childCounts.currentErrorCnt || 0);
    });

    counts.childErrorCnt = childErrorCnt;
    counts.totalErrorCnt = childErrorCnt + counts.nodeErrorCnt;
    counts.currentErrorCnt = currentErrorCnt;

    return countMap;
}


// WEBPACK FOOTER //
// ./src/components/widget/util/StateUtil.ts